import React, { Component, Fragment } from 'react';
import { Row, Col, Tab, Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment';
import Auth from '../../Auth/Auth';

import SimpleWordcloud from './WordClouds';
import FetchProStats from './FetchProStats';
import SearchMetrics from './SearchMetrics';
import ProcessLogging from './ProcessLogging';
import SearchCrawlHealth from './SearchCrawlHealth';
import Feedback from './Feedback';
import Cuteness from './Cuteness';
import IsLoadingBar from '../isLoading';

import './FetchVClientSearch.scss';
import dogIcon from '../../images/10607-dog-avatar.png';

const auth = new Auth();

export default class FetchVClientSearch extends Component {
    constructor(props){
        super(props);

        this.state = {
            fetchSearches: [],
            FetchProStats: [],
            SearchdataLoading: true,
            FetchProDataLoading: true,
            FetchDataLoading: true,
            ClientDataLoading: true,
            fullLeft: false,
            fullRight:false,
            activeTab: "searchMetrics",
            activeTabClient: "searchMetrics"
        };
    }

    async componentDidMount(){
        let offsetMinutes = new Date().getTimezoneOffset();
        let accessToken = await auth.getToken();
        let today = new Date();
        let Sunday = new Date(today.getTime() - today.getDay() * 24 * 3600 * 1000);

        var dateObj = new Date();
        dateObj.setDate(0)
        var month = dateObj.getMonth() + 1;
        var day = dateObj.getDate();
        var year = dateObj.getFullYear();
        let newdate = month + "/" + day + "/" + year;

        fetch('/api/getDateSearchKPI', {
            method : "GET",
            headers : {
                'Authorization': "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true,
                'offset' : offsetMinutes
            }
        }).then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        }).then(data => {
            var Searchdata = data[0];
            if(Searchdata){
                this.setState({
                    Today: Searchdata.Today,
                    SevenDaysBack: Searchdata.SevenDaysBack,
                    ThirtyDaysBack: Searchdata.ThirtyDaysBack,
                    YearBack: Searchdata.YearBack,
                    CurrentWeek: Searchdata.CurrentWeek,
                    PreviousWeek: Searchdata.PreviousWeek,
                    CurrentMonth: Searchdata.CurrentMonth,
                    PreviousMonth: Searchdata.PreviousMonth,
                    Filtered: Searchdata.filtered,
                    Basic: Searchdata.basic,
                    smartPanelDisplayed: Searchdata.smartPanelDisplayed,
                    AvgResponseTime : Searchdata.AvgResponseTime,
                    smartPanelInteracted: Searchdata.smartPanelInteracted,
                    daysAgo: [{
                        daysago7: Searchdata.daysago7,
                        daysago6: Searchdata.daysago6,
                        daysago5: Searchdata.daysago5,
                        daysago4: Searchdata.daysago4,
                        daysago3: Searchdata.daysago3,
                        daysago2: Searchdata.daysago2,
                        daysago1: Searchdata.daysago1,
                    }],
                    SearchdataLoading : false,
                });
            } else {
                this.setState({
                    SearchdataLoading : false,
                });
            }          
        }).catch((error) => {
            window.apiError(error);
        });

        const promise1 =  new Promise((resolve, reject) => {
            fetch('/api/getSearchExpressionsKPI', {
            method : "GET",
            headers : {
                'Authorization': "Bearer " + accessToken, 
                withCredentials : true,
                crossDomain: true,
            }
            }).then(success => success.json())
            .then(data => {
                if(data[0] !== undefined){
                    var SearchExpressions = data[0][0];
                    if(SearchExpressions){
                        this.setState({
                            AvgPage:  SearchExpressions.AvgPage,
                            AvgResult:  SearchExpressions.AvgResult,
                            KPILoading : false,
                        });
                    
                    } else {
                        this.setState({
                            KPILoading : false,
                        });
                    }  
                } else {
                    this.setState({
                        KPILoading : false,
                    });
                }  
                resolve(true);        
            }).catch((error) => {
                window.apiError(error);
                resolve(false);
            });
        });

        const promise2 = new Promise((resolve, reject) => { 
            fetch('/api/getFetchProStats', {
            method : "GET",
            headers : {
                'Authorization': "Bearer " + accessToken, 
                withCredentials : true,
                crossDomain: true,
            }
            }).then(success => success.json())
            .then(data => {
                this.setState({
                    FetchProStats: data,
                    FetchProDataLoading: false
                });
                resolve(true);
            }).catch((error) => {
                window.apiError(error);
                resolve(false);
            });
        });

        const promise3 = new Promise((resolve, reject) => {
             fetch('/api/wordCloudFetch', {
            method : "GET",
            headers : {
                'Authorization': "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true,
                datefilter: moment.utc(newdate).format('YYYY/MM/DD')
            }
            }).then(response => {
                if(response.status !== 200)
                {   
                    let payload = [{
                        status : response.status,
                        rawmsg : response.statusText,
                        cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                        location: response.url,
                        timestamp : Date.now(),
                    }];
                    throw {
                        payload: payload,
                        error: new Error()
                    };
                }
                return  response.json();
            }).then(data => {
            this.setState({
                fetchSearches : data[0],
                fetchSearchesDate: moment.utc(newdate).format('YYYY/MM/DD')
            });
            resolve(true);            
            }).catch((error) => {
                window.apiError(error);
                resolve(false);
            });
        });

        const promiseClient1  = new Promise((resolve, reject) => {
             fetch('/api/wordCloudClient', {
            method : "GET",
            headers : {
                'Authorization': "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true,
                datefilter: moment.utc(newdate).format('YYYY/MM/DD')
            }
            }).then(response => {
                if(response.status !== 200)
                {   
                    let payload = [{
                        status : response.status,
                        rawmsg : response.statusText,
                        cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                        location: response.url,
                        timestamp : Date.now(),
                    }];
                    throw {
                        payload: payload,
                        error: new Error()
                    };
                }
                return  response.json();
            }).then(data => {
            this.setState({
                clientSearches : data[0],
                clientSearchesDate: moment.utc(newdate).format('YYYY/MM/DD')
            });
            resolve(true)                  
            }).catch((error) => {
                window.apiError(error);
                resolve(false);
            });
        });

        Promise.all([promise1, promise2, promise3]).then((values) => {
            this.setState({
                FetchDataLoading : false
            });
        });

        Promise.all([promiseClient1]).then((values) => {
            this.setState({
                ClientDataLoading : false
            });
        });
        

    }
    
    render(){
        return (
            <Row id="fetch_client_search">
                <Col lg={!this.state.fullLeft ? { span: 6 } : { span: 11}} id="fetch-analytics" style={this.state.fullRight ? {display : "none"} : {}}>   
                    {this.state.FetchDataLoading ?
                        <div style={{marginTop: '25%'}}>
                            <IsLoadingBar alttext={"Fetching Analytics"} customWording={"Fetching Analytics"} />
                        </div>                        
                    :                 
                    <Tab.Container defaultActiveKey={this.state.activeTab}>
                        <Row>
                            <Col lg={{ span : 1}} className={!this.state.fullLeft ? "tab-row text-center" : "tab-row text-center full-left"}>
                                <Nav variant="tabs">
                                    <Nav.Item>                                        
                                        <Nav.Link onClick={() => this.setState({ fullLeft: !this.state.fullLeft })}>
                                            <OverlayTrigger
                                                placement={"right"}
                                                overlay={
                                                <Tooltip id={`tooltip-top`}>
                                                    Expand Column
                                                </Tooltip>
                                                }
                                            >
                                                <i className={!this.state.fullLeft ? "fas fa-arrow-right" : "fas fa-arrow-left" }></i>
                                            </OverlayTrigger>                                            
                                            </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>                                        
                                        <Nav.Link eventKey="searchMetrics" onClick={() => this.setState({ activeTab : "searchMetrics" })}>
                                        <OverlayTrigger
                                                placement={"right"}
                                                overlay={
                                                <Tooltip id={`tooltip-top`}>
                                                    Search Metrics
                                                </Tooltip>
                                                }
                                            >
                                                <i className="fas fa-search"></i>
                                            </OverlayTrigger>                                            
                                        </Nav.Link>
                                    </Nav.Item>
                                    {/* <Nav.Item>
                                        <Nav.Link eventKey="fetchProStats" onClick={() => this.setState({ activeTab : "fetchProStats" })}><i className="far fa-lightbulb"></i></Nav.Link>
                                    </Nav.Item> */}
                                    <Nav.Item>
                                        <Nav.Link eventKey="wordCloud" onClick={() => this.setState({ activeTab : "wordCloud" })}>
                                        <OverlayTrigger
                                                placement={"right"}
                                                overlay={
                                                <Tooltip id={`tooltip-top`}>
                                                    Most Searched Words
                                                </Tooltip>
                                                }
                                            >
                                                <i className="fas fa-cloud"></i>
                                        </OverlayTrigger>                                                
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="status" onClick={() => this.setState({ activeTab : "status" })}>
                                            <OverlayTrigger
                                                placement={"right"}
                                                overlay={
                                                <Tooltip id={`tooltip-top`}>
                                                    Fetch Status
                                                </Tooltip>
                                                }
                                            >
                                                <i className="fas fa-info-circle"></i>
                                            </OverlayTrigger>  
                                        </Nav.Link>
                                    </Nav.Item>
                                    {this.props.isAdmin && (
                                        <Fragment>
                                            <Nav.Item>
                                                <Nav.Link eventKey="feedback" onClick={() => this.setState({ activeTab : "feedback" })}>
                                                <OverlayTrigger
                                                    placement={"right"}
                                                    overlay={
                                                    <Tooltip id={`tooltip-top`}>
                                                        Submitted Feedback
                                                    </Tooltip>
                                                    }
                                                >
                                                    <i className="far fa-comment-alt"></i>
                                                </OverlayTrigger>                                                      
                                                </Nav.Link>
                                            </Nav.Item> 
                                            <Nav.Item>
                                                <Nav.Link eventKey="cuteness" onClick={() => this.setState({ activeTab : "cuteness" })}>
                                                <OverlayTrigger
                                                    placement={"right"}
                                                    overlay={
                                                    <Tooltip id={`tooltip-top`}>
                                                        Submitted Cuteness Photos
                                                    </Tooltip>
                                                    }
                                                >
                                                    <i className="fas fa-paw"></i>
                                                </OverlayTrigger>                                                      
                                                </Nav.Link>
                                            </Nav.Item> 
                                        </Fragment>                                        
                                    )}
                                                                       
                                </Nav>
                            </Col>
                            <Col lg={{ span : 11}}>
                                <h3>Fetch</h3>
                                <Tab.Content className="w-100">
                                    <Tab.Pane eventKey="searchMetrics">
                                        <SearchMetrics metric={this.state} />
                                    </Tab.Pane>
                                     <Tab.Pane eventKey="fetchProStats">
                                        <FetchProStats metric={this.state.FetchProStats} />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="wordCloud">
                                            {this.state.activeTab === "wordCloud" && (
                                                <SimpleWordcloud words={this.state.fetchSearches} searchesDate={this.state.fetchSearchesDate} area={'Fetch'} />
                                            )}                                 
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="status">                                        
                                        {this.state.activeTab === "status" && (
                                            <div>
                                                <SearchCrawlHealth />     
                                                <ProcessLogging />   
                                            </div>   
                                        )}                                                         
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="feedback">
                                        {this.state.activeTab === "feedback" && (
                                            <Feedback Feedback={this.state.Feedback} />
                                        )}
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="cuteness">
                                        {this.state.activeTab === "cuteness" && (
                                            <Cuteness />
                                        )}
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </Row>                                        
                    </Tab.Container>
                    }   
                </Col>
                <Col  lg={!this.state.fullRight ? { span: 6 } : { span: 11}}  id="client-analytics" style={this.state.fullLeft ? {display : "none"} : {}}>
                    {this.state.ClientDataLoading ?
                        <div style={{marginTop: '25%'}}>
                            <IsLoadingBar alttext={"Fetching Analytics"} customWording={"Fetching Analytics"} />
                        </div>
                    :       
                    <Tab.Container  defaultActiveKey={this.state.activeTabClient}>
                        <Row>
                            <Col lg={{ span : 1}} className="tab-row">
                                <Nav variant="tabs">
                                    <Nav.Item>                                        
                                        <Nav.Link onClick={() => this.setState({ fullRight: !this.state.fullRight })}>
                                        <OverlayTrigger
                                            placement={"right"}
                                            overlay={
                                            <Tooltip id={`tooltip-top`}>
                                                Expand Column
                                            </Tooltip>
                                            }
                                        >
                                            <i className={!this.state.fullRight ? "fas fa-arrow-left" : "fas fa-arrow-right" }></i>
                                        </OverlayTrigger>
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>                                        
                                        <Nav.Link eventKey="searchMetrics">
                                        <OverlayTrigger
                                            placement={"right"}
                                            overlay={
                                            <Tooltip id={`tooltip-top`}>
                                                Search Metrics
                                            </Tooltip>
                                            }
                                        >
                                            <i className="fas fa-search"></i>
                                        </OverlayTrigger>
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="wordCloud" onClick={() => this.setState({ activeTabClient : "wordCloud" })}>
                                        <OverlayTrigger
                                            placement={"right"}
                                            overlay={
                                            <Tooltip id={`tooltip-top`}>
                                                Most Searched Words
                                            </Tooltip>
                                            }
                                        >
                                            <i className="fas fa-cloud"></i>
                                        </OverlayTrigger>
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Col>
                            <Col lg={{ span : 11}}>
                                <h3>Client</h3>
                                <Tab.Content className="w-100">
                                    <Tab.Pane eventKey="searchMetrics">
                                        <div className="overlay">
                                            <img src={dogIcon} />
                                            <h1>No Metrics are available for the client side yet.<br /> please check back soon</h1>
                                        </div>
                                        <SearchMetrics metric={[]} />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="wordCloud" id="wordcloud_container">                                       
                                        {this.state.activeTabClient === "wordCloud" && (
                                            <SimpleWordcloud words={this.state.clientSearches} searchesDate={this.state.clientSearchesDate} area={'Client'} />
                                        )}                                  
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </Row>                                        
                    </Tab.Container> 
                    } 
                </Col>                  
            </Row>
        );
    }
}

